import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type BrandAndFooter, type TrackingConfig } from '~/types/TrackingSettings';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type TrackingSettingsState = {
  readonly brandAndFooterUpdateRequest: Requestable<BrandAndFooter, string>;
  readonly trackingConfig: Requestable<TrackingConfig, string>;
  readonly trackingConfigUpdateRequest: Requestable<TrackingConfig, string>;
};

const initialState: TrackingSettingsState = {
  brandAndFooterUpdateRequest: getNotRequested(),
  trackingConfig: getNotRequested(),
  trackingConfigUpdateRequest: getNotRequested(),
};

const trackingSettingsReducer = (
  state: TrackingSettingsState = initialState,
  action: ActionTypes,
): TrackingSettingsState => {
  switch (action.type) {
    case ActionKeys.FETCH_TRACKING_CONFIG:
      return {
        ...state,
        trackingConfig: getRequesting(),
      };
    case ActionKeys.FETCH_TRACKING_CONFIG_SUCCESS:
      return {
        ...state,
        trackingConfig: getSuccess(action.payload),
      };
    case ActionKeys.FETCH_TRACKING_CONFIG_ERROR:
      return {
        ...state,
        trackingConfig: getFailed(action.payload.error),
      };
    case ActionKeys.UPDATE_TRACKING_CONFIG:
      return {
        ...state,
        trackingConfigUpdateRequest: getRequesting(),
      };
    case ActionKeys.UPDATE_TRACKING_CONFIG_SUCCESS:
      return {
        ...state,
        trackingConfigUpdateRequest: getSuccess(action.payload),
      };
    case ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS:
      return {
        ...state,
        brandAndFooterUpdateRequest: getRequesting(),
      };
    case ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_SUCCESS:
      return {
        ...state,
        brandAndFooterUpdateRequest: getSuccess(action.payload),
      };
    case ActionKeys.UPDATE_BRAND_AND_FOOTER_SETTINGS_ERROR:
      return {
        ...state,
        brandAndFooterUpdateRequest: getFailed(action.payload.error),
      };
    default:
      return state;
  }
};

export default trackingSettingsReducer;
